/* eslint-disable no-console */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  public static info(message: string, grouped = false, heading = ''): void {
    if (grouped) {
      this.writeToConsoleGrouped(heading || `info`, message, `color: green;`);
    } else {
      this.writeToConsole(heading || `info`, message, `color: green;`);
    }
  }

  public static debug(message: string, grouped = false, logDebug = false, heading = ''): void {
    if (!logDebug) {
      return;
    }
    if (grouped) {
      this.writeToConsoleGrouped(heading || `debug`, message, `color: lightblue;`);
    } else {
      this.writeToConsole(heading || `debug`, message, `color: lightblue;`);
    }
  }

  public static error(message: string, grouped = false, heading = ''): void {
    if (grouped) {
      this.writeToConsoleGrouped(heading || `error`, message, `color: red;`);
    } else {
      this.writeToConsole(heading || `error`, message, `color: red;`);
    }
  }

  private static writeToConsoleGrouped(heading: string, message: string, style: string): void {
    console.groupCollapsed(`%c${heading.toUpperCase()}`, `${style}`);
    console.log(message);
    console.groupEnd();
  }

  private static writeToConsole(heading: string, message: string, style: string): void {
    console.log(`%c${heading.toUpperCase()}: ${message}`, `${style}`);
  }
}
